import React from 'react'
import styled from 'styled-components'
import { Container } from 'react-grid-system'
import { Link as RouterLink } from 'react-router-dom'

import { Link } from 'adl'
import LogoCard from 'components/LogoCard'

const HeroSection = styled.section`
  background-image: url(${props => props.theme.branding.marketingImage});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  flex-direction: row;
  align-items: center;
  min-height: 100%;
`

function SignInPage() {
  return (
    <HeroSection>
      <Container>
        <LogoCard
          className="shadow-huge"
          style={{ maxWidth: 360, marginLeft: 'auto', marginRight: 'auto' }}
        >
          <div style={{ paddingTop: 40, paddingBottom: 40 }}>
            <h3 style={{ marginBottom: 16, textAlign: 'center' }}>
              Signed Out
            </h3>
            <p>You have successfully signed out from the demo.</p>
          </div>

          <div style={{ textAlign: 'center', marginBottom: 32 }}>
            <Link as={RouterLink} to="/sign-in">
              Sign In Again
            </Link>
          </div>
        </LogoCard>
      </Container>
    </HeroSection>
  )
}

export default SignInPage
